module.exports = __webpack_public_path__ + "img/sunshine-background.f669b988.jpg";